/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { Link, Button, Grid, TextField, Typography, Box } from '@mui/material';
import { isEmailValid } from '../../../utils';
import { useTranslation } from 'react-i18next';
import useNswagClient from '../../../hooks/api/useNswagClient';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';

const ForgotPassword = (props: { switchDisplay: () => void }) => {
  const { t } = useTranslation('authentication');
  const { resetPassword } = useNswagClient();
  const [email, setEmail] = useState('');
  const [sentEmail, setSentEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
    setEmailError('');
  };

  const isFormValid = () => {
    if (!email) {
      setEmailError('Enter your email');
      return false;
    }

    if (!isEmailValid(email)) {
      setEmailError('Enter an email address in the correct format, like name@example.com');
      return false;
    }

    return true;
  };

  const sendResetPasswordRequest = () => {
    resetPassword({ emailAddress: email })
      .then(() => {
        setSentEmail(email);
        setShowMessage((showMessage) => !showMessage);
        setEmail('');
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (isFormValid()) {
      sendResetPasswordRequest();
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: 'center', width: '360px' }}>

      <Typography variant="displaySM"
        fontWeight={600}
        sx={{ textAlign: 'start' }}>{t('forgotPasswordTitle')}</Typography>
      <Typography color="textSecondary"
        variant="textMD"
        sx={{ mt: '12px' }}>
        {t('forgotPasswordMessage')}
      </Typography>
      <Box>
        <TextField InputLabelProps={{ shrink: true }}
          sx={{ mt: 9 }}
          value={email}
          onChange={handleEmailChange}
          variant="outlined"
          label='Email'
          error={!!emailError}
          helperText={emailError}
          FormHelperTextProps={{
            sx: {
              marginLeft: 0, // Removes the default left margin
            },
          }}
          required
          fullWidth />
        <Grid sx={{ pt: 8 }}>
          <Button
            type='submit'
            variant="primary"
            fullWidth
            onClick={handleSubmit}>
            {t('forgotPasswordSubmit')}
          </Button>
        </Grid>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 4 }}>
        <Typography color="textSecondary"
          variant="textMD">
          {t('forgotPasswordReturnToLogin')}
        </Typography>
        <Link fontWeight={600}
          variant="textMD"
          sx={{ ml: 1 }}
          onClick={props.switchDisplay}
          href="#" >
          {t('signInLink')}
        </Link>
      </Box>

      <MessagesSnackbar open={showMessage}
        severity='success'
        message={t('forgotPasswordSuccess', { email: sentEmail })}
        onClose={() => setShowMessage(false)}
        duration={15000}
        horizontalPosition='left' />

    </Box>
  );
};

export default ForgotPassword;